<template>
    <div>
        <div class="video-placeholder w-full flex flex-col justify-center items-center rounded overflow-hidden">
            <video v-if="video" :src="video" class="w-full block" muted autoplay loop playsinline></video>
            <div v-else class="w-full flex flex-col justify-center items-center gap-4 py-10">
                <feather-icon icon="FilmIcon" svgClasses="h-16 w-16 text-primary" />
                <p v-if="constraintsText" class="text-xs font-semibold">{{ constraintsText }}</p>
            </div>
        </div>
        <div class="mt-3 flex flex-row gap-2 items-center">
            <vs-button :disabled="disabled" type="border" class="button-select-video inline-block rounded-lg py-2" @click="handlerChooseFiles()">{{ selectText }}</vs-button>

            <vs-button :disabled="disabled" v-if="video" type="border" color="danger" class="delete-row rounded-lg px-3 py-2 text-danger" @click="handlerDelete">
                <feather-icon icon="TrashIcon" class="align-middle" svgClasses="align-middle w-4"/>
            </vs-button>
        </div>
        <vs-input
            type="file"
            accept="video/mp4"
            :name="name"
            hidden
            ref="input"
            @change="onFileChange"
            :danger="validateError"
            :danger-text="errorMessage"
        />
    </div>
</template>

<script>

export default {
    name: 'video-form',
    props: {
        'src': String,
        'name': String,
        'constraintsText': String,
        'selectText': String,
        'validWidth': { type: Number, default: 640 },
        'validHeight': { type: Number, default: 960 },
        // Max file weight in KB (3 MB by default).
        'maxWeightKb': { type: Number, default: 3072 },
        'invalidDimensionsMessage': String,
        'tooLargeMessage': String,
        'invalidFormatMessage': String,
        'disabled': {
            'type': Boolean,
            'default': false
        },
    },
    data() {
        return {
            videoData: null,
            validateError: false,
            errorMessage: ''
        }
    },
    computed: {
        video() {
            return this.videoData ? this.videoData : this.src
        }
    },
    watch: {
        'src': function() {
            this.videoData = null
        }
    },
    methods: {
        handlerChooseFiles() {
            this.$refs.input.$el.querySelector('input').click()
        },
        onFileChange(e) {
            const file = e.target.files[0];
            if (!file) {
                return
            }

            // Best-effort container check. H.264 codec is enforced by the API (403).
            const isMp4 = file.type === 'video/mp4' || /\.mp4$/i.test(file.name)
            if (!isMp4) {
                return this.fail(this.invalidFormatMessage)
            }

            if (file.size / 1024 > this.maxWeightKb) {
                return this.fail(this.tooLargeMessage)
            }

            const url = URL.createObjectURL(file);
            const videoEl = document.createElement('video');
            const that = this;

            videoEl.preload = 'metadata';
            videoEl.onloadedmetadata = function() {
                if (videoEl.videoWidth !== that.validWidth || videoEl.videoHeight !== that.validHeight) {
                    return that.fail(that.invalidDimensionsMessage)
                }

                that.videoData = url;
                that.validateError = false;
                that.errorMessage = '';
                that.$emit('updateVideo', file);
                that.$emit('input', url);
            };
            videoEl.onerror = function() {
                that.fail(that.invalidFormatMessage)
            };
            videoEl.src = url;
        },
        fail(message) {
            this.validateError = true;
            this.errorMessage = message;
            this.$emit('updateVideo', null);
        },
        handlerDelete() {
            this.videoData = null;
            this.$emit('updateVideo', null);
            this.$emit('input', null);
        }
    }
}
</script>

<style scoped>

.video-placeholder {
  background-color: #F4F4FA;
}
</style>
